import { Form as AccountingPolicyFormComponent } from "./AccountingPolicy.js";

export const AccountingPolicyForm = AccountingPolicyFormComponent;
